module.exports = __webpack_public_path__ + "files/4eb95681689c6b88e84899b5320c6016.png";